import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import UITextToolbarIcon from 'rich-text-lib/components/editor/UITextToolbarIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { jsx as _jsx } from "react/jsx-runtime";
const clearMarks = (schema, tr, from, to) => {
  const excludedMarks = ['link'];
  Object.keys(schema.marks).filter(val => !excludedMarks.includes(val)).forEach(mark => {
    if (schema.marks[mark]) {
      tr = tr.removeMark(from, to, schema.marks[mark]);
    }
  });
  return tr;
};
export default function ClearFormatting({
  defaultFontSize,
  defaultFontStyle,
  defaultTextColor
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const clearFormatting = useCallback(e => {
    e.preventDefault();
    let tr = editorState.tr;
    const {
      schema
    } = editorState;
    const {
      from,
      to
    } = tr.selection;
    tr = clearMarks(schema, tr, from, to);
    editorState.doc.nodesBetween(from, to, (node, pos) => {
      if (node.type === schema.nodes.heading) {
        tr = tr.replaceWith(pos, pos + node.nodeSize, node.content);
        tr = clearMarks(schema, tr, pos, pos + node.nodeSize);
      }
    });
    tr = tr.setMeta('font_size', defaultFontSize);
    tr = tr.setMeta('font_style', defaultFontStyle);
    tr = tr.setMeta('text_color', defaultTextColor);
    setEditorState(editorState.apply(tr));
  }, [editorState, setEditorState, defaultFontSize, defaultFontStyle, defaultTextColor]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.clearFormatting"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      "data-test-id": "removeTextStyle",
      onMouseDown: clearFormatting,
      selected: false,
      children: /*#__PURE__*/_jsx(UITextToolbarIcon, {
        name: "removeTextStyle"
      })
    })
  });
}